import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
@Injectable()
export class CompanySearchService {

  public companyId

  private companyIdSubject = new Subject<number>();
  companyId$ = this.companyIdSubject.asObservable();
  setCompanySearch$ = this.companyIdSubject.asObservable();

  private triggerReloadCompanyListSubject = new Subject<void>();
  triggerReloadCompanyList$ = this.triggerReloadCompanyListSubject.asObservable();

  private triggerRefreshBalancesSubject = new Subject<void>();
  triggerRefreshBalances$ = this.triggerRefreshBalancesSubject.asObservable();

  constructor() { }
  sendCompanyId(message: number){
    this.companyId = message;
    this.companyIdSubject.next(message);
  }

  setCompanySearch(message: number){
    this.companyId = message;
    this.companyIdSubject.next(message);
  }

  triggerReloadCompanyList() {
    this.triggerReloadCompanyListSubject.next();
  }

  triggerRefreshBalances() {
    this.triggerRefreshBalancesSubject.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/fleet-manager/company-search-bar/company-search.service.ts